import React from 'react';
import { RingsOverview } from '../metrics/rings/RingsOverview';
import { MetricTiles } from '../metrics/MetricTiles';
import { JournalTile } from '../JournalTile';
import { MyActivities } from '../activities/MyActivities';
import { DailyWorkoutSuggestions } from '../workouts/DailyWorkoutSuggestions';
import { DashboardItem } from '../DashboardItem';
import { EditDashboardButton } from '../EditDashboardButton';
import { AskDrogoBar } from '../AskDrogoBar';
import { FloatingMenu } from '../FloatingMenu';
import { HealthMetricsSummary } from '../health/HealthMetricsSummary';
import { HealthMetrics } from '../../types/health';
import { useVacationMode } from '../../features/vacation';
import { useProfileStore } from '../../store/profileStore';
import { WorkoutSuggestion } from '../WorkoutSuggestion';

interface OverviewTabProps {
  metrics: HealthMetrics;
}

export function OverviewTab({ metrics }: OverviewTabProps) {
  const { isVacationMode } = useVacationMode();
  const { isNerdMode } = useProfileStore();

  return (
    <div className="space-y-2 sm:space-y-4 pb-24 pt-2 sm:pt-0">
      {/* Rings Overview */}
      {!isVacationMode && (
        <DashboardItem id="rings-overview" className="theme-card py-4 px-4 relative overflow-hidden bg-background/30 border-border/30">
          <RingsOverview metrics={metrics} />
        </DashboardItem>
      )}

      {/* Hide Items Button */}
      <div className="flex justify-end px-4">
        <EditDashboardButton />
      </div>

      {/* Ask Drogo Bar */}
      <DashboardItem id="ask-drogo">
        <AskDrogoBar />
      </DashboardItem>

      {/* Health Metrics Summary */}
      {!isVacationMode && (
        <DashboardItem id="health-metrics">
          <HealthMetricsSummary />
        </DashboardItem>
      )}

      {/* Metric Tiles */}
      <DashboardItem id="metric-tiles">
        <MetricTiles metrics={metrics} />
      </DashboardItem>

      {/* Habits Tracker */}
      <DashboardItem id="habits-tracker">
        <JournalTile />
      </DashboardItem>

      {/* Today's Activities */}
      <DashboardItem id="activities">
        <MyActivities />
      </DashboardItem>

      {/* Today's Workout */}
      {!isVacationMode && (
        <DashboardItem id="workout-suggestions">
          <DailyWorkoutSuggestions
            onSchedule={(workout, slot) => {
              console.log('Schedule workout:', workout, slot);
            }}
          />
        </DashboardItem>
      )}

      {/* Today's Suggested Workout */}
      {!isVacationMode && (
        <DashboardItem id="suggested-workout">
          <WorkoutSuggestion 
            readiness={metrics.readiness} 
            recovery={metrics.recovery} 
          />
        </DashboardItem>
      )}

      {/* Floating Menu */}
      <FloatingMenu />
    </div>
  );
}